import React from "react";
import Swal from "sweetalert2";
import CalenderBooking from "./CalenderBooking";
import useFetchApi from "../../hooks/useFetchApi";
import usePagination from "../../hooks/usePagination";
import { authHeaders } from "../../utils/api";
import { BOOKING_TABLE_STATUS_URL, BOOKING_TABLE_URL } from "../../utils/Constant";


function BookingTable() {

    const { data, setData, loading, error, refetch: fetchData } = useFetchApi({
        url: BOOKING_TABLE_URL,
        dataKey: 'recentBookings',
        authType: 'admin'// ✅ auth token
    });



    const {
        currentItems,
        getVisiblePages,
        currentPage,
        setCurrentPage,
        handlePrev,
        handleNext,
        totalPageNo
    } = usePagination({ data: data, itemShowPerPage: 5 });

    // =========================
    // Approve Booking
    // =========================
    const handleApprove = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to approve this booking",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#22c55e",
            cancelButtonColor: "#ef4444",
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: "Processing...",
            text: "Please wait",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            const res = await fetch(
                BOOKING_TABLE_STATUS_URL,
                {
                    method: "POST",
                    headers: authHeaders(), // ✅
                    body: JSON.stringify({ id, status: 2 }),
                }
            );

            if (!res.ok) throw new Error(`Server error: ${res.status}`);

            const data = await res.json();

            if (data.success) {
                Swal.fire({
                    title: "Approved!",
                    text: "Booking approved successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
                fetchData();
            } else {
                Swal.fire({
                    title: "Error",
                    text: data.message || "Something went wrong",
                    icon: "error",
                });
            }

        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error.message || "Something went wrong",
                icon: "error",
            });
        }
    };

    // =========================
    // Reject Booking
    // =========================
    const handleReject = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to reject this booking",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Reject",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#22c55e",
            cancelButtonColor: "#ef4444",
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: "Processing...",
            text: "Please wait",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            const res = await fetch(
                BOOKING_TABLE_STATUS_URL,
                {
                    method: 'POST',
                    headers: authHeaders(), // ✅
                    body: JSON.stringify({ id, status: 3 }),
                }
            );

            if (!res.ok) throw new Error(`Server error: ${res.status}`);

            const data = await res.json();

            if (data.success) {
                Swal.fire({
                    title: "Rejected!",
                    text: "Booking rejected successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
                fetchData();
            } else {
                Swal.fire({
                    title: "Error",
                    text: data.message || "Something went wrong",
                    icon: "error",
                });
            }

        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error.message || "Something went wrong",
                icon: "error",
            });
        }
    };

    // =========================
    // LOADING / ERROR
    // =========================
    if (loading) return (
        <div className="text-center p-4">
            <span className="loading loading-bars loading-lg"></span>
        </div>
    );

    if (error) return (
        <p className="text-red-500 p-4">{error}</p>
    );

    return (
        <>
            <div className="bg-white rounded shadow-lg mt-5">
                <h4 className="text-lg p-4 font-semibold border-b">Recent Bookings</h4>

                <div className="p-4">
                    <table className="w-full border">
                        <thead className="bg-gray-400">
                            <tr className="border p-2">
                                <th className="border p-2">Sl No.</th>
                                <th className="border p-2">Users</th>
                                <th className="border p-2">Mandap</th>
                                <th className="border p-2">Date</th>
                                <th className="border p-2">Price</th>
                                <th className="border p-2">Status</th>
                                <th className="border p-2">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentItems.map((item, index) => {
                                const {
                                    user: { name: userName },
                                    mandap: { name: mandapName },
                                    from_date,
                                    to_date,
                                    price,
                                    status,
                                    status_label,
                                    status_badge,
                                    id
                                } = item;

                                return (
                                    <tr className="border p-2" key={id}>
                                        <td className="border p-2 text-center">{index + 1}</td>
                                        <td className="border p-2">{userName}</td>
                                        <td className="border p-2">{mandapName}</td>
                                        <td className="border p-2">{`${from_date} - ${to_date}`}</td>
                                        <td className="border p-2">
                                            <b>₹</b>{price}
                                        </td>
                                        <td className="border p-2">
                                            <span className={`badge badge-${status_badge} badge-outline`}>
                                                {status_label}
                                            </span>
                                        </td>
                                        <td className="border p-2">
                                            {/* <div className="dropdown dropdown-end">
                                                <div tabIndex={0} role="button" className="btn btn-xs btn-info m-1">
                                                    Action
                                                </div>
                                                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                                                    <li>
                                                        <button
                                                            onClick={() => handleApprove(id)}
                                                            className="text-green-500"
                                                        >
                                                            Approve
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            onClick={() => handleReject(id)}
                                                            className="text-red-500"
                                                        >
                                                            Reject
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div> */}

                                            {status === 1 ? (
                                                <div className="dropdown dropdown-end">
                                                    <div
                                                        tabIndex={0}
                                                        role="button"
                                                        className="btn btn-xs btn-info m-1"
                                                    >
                                                        Action
                                                    </div>

                                                    <ul
                                                        tabIndex={0}
                                                        className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
                                                    >
                                                        <li>
                                                            <button
                                                                onClick={() => handleApprove(id)}
                                                                className="text-green-500"
                                                            >
                                                                Approve
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button
                                                                onClick={() => handleReject(id)}
                                                                className="text-red-500"
                                                            >
                                                                Reject
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            ) : (
                                                <span className="text-gray-500 text-sm">
                                                    No Action
                                                </span>
                                            )}

                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="paginationContainer flex justify-between items-center mt-6 p-3 bg-white rounded">
                        <button
                            className="join-item btn btn-outline"
                            onClick={handlePrev}
                        >
                            Previous page
                        </button>

                        <div className="join">
                            {getVisiblePages().map((page) => (
                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`join-item btn btn-sm ${currentPage === page
                                        ? "btn-primary text-white"
                                        : "btn-outline"
                                        }`}
                                >
                                    {page + 1}
                                </button>
                            ))}
                        </div>

                        <button
                            className="join-item btn btn-outline"
                            onClick={handleNext}
                        >
                            Next
                        </button>

                        <div className="mt-4">
                            <p>
                                Showing page <b>{currentPage + 1}</b> of <b>{totalPageNo}</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <CalenderBooking />
        </>
    );
}

export default BookingTable;